let accordionSlider = null;

function initAccordion() {
    const isMobile = window.innerWidth <= 900;

    if (isMobile && !accordionSlider) {
        accordionSlider = new Swiper('.accordion-slider', {
            slidesPerView: 1,
            spaceBetween: 10,
            loop: true,
        });
    } else if (!isMobile && accordionSlider) {
        accordionSlider.destroy(true, true);
        accordionSlider = null;
    }

    if (!isMobile) {
        const accordionItems = document.querySelectorAll('.accordion-item');
        accordionItems.forEach((item) => {
            item.addEventListener('mouseenter', function () {
                accordionItems.forEach((i) => i.classList.remove('active'));
                item.classList.add('active');
            });
        });
    }
}

document.addEventListener('DOMContentLoaded', initAccordion);

let resizeTimeout;
window.addEventListener('resize', function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(initAccordion, 150);
});
